import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { Box,  Typography } from "@mui/material";

import { Stack,Typography, Box } from "@mui/material";
import { useParams } from "react-router-dom";

import { fetchFromAPI } from "../utils/fetchFromAPI";
import { Videos,Side, Channels } from "./";

const SearchFeed = () => {
  const [videos, setVideos] = useState(null);
  const [channels, setChannels] = useState(null);
  const { searchTerm } = useParams();
  // const [selectedCategory, setSelectedCategory] = useState("");
  // const navigate = useNavigate();


  useEffect(() => {
    fetchFromAPI(`search?part=snippet&q=${searchTerm}`)
      .then((data) => {
        
        var videos = data.items.filter((i) => i.id.kind !== "youtube#channel")
        var channels = data.items.filter((i) => i.id.kind === "youtube#channel")
        console.log(videos)
        setChannels(channels)
        setVideos(videos)
      })
  }, [searchTerm]);

    

  return (
    <Box sx={{ overflowY: "auto", height: "80vh", flex: 2 }} >
      <Stack sx={{ flexDirection: "column" }}>

      
          {/* <Typography variant="h4" fontWeight={900}  color="white" mb={3} > */}
            {/* Search Results for <span style={{ color: "#FC1503" }}>{searchTerm}</span> Channels */}
          {/* </Typography> */}
        <Channels channels={channels} direction="column" />
      
            

      <Box p={2} minHeight="95vh" overflowY= "auto">
        {/* <Typography variant="h4" fontWeight={900}  color="white" mb={3} >
          Search Results for <span style={{ color: "#FC1503" }}>{searchTerm}</span> videos
        </Typography> */}
        <Videos videos={videos} />
      </Box>
      </Stack>
    </Box>
    
    
  );
};

export default SearchFeed;